"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.multisportify = void 0;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var soccerKeyRX = /^soccer_/gi;

var multisportify = function multisportify(orig) {
  if (orig === null || orig === undefined) {
    // abort if obj is null or undefined
    return;
  }

  var obj = JSON.parse(JSON.stringify(orig)); // update all of this objects keys

  upgradeSoccerAttributes(obj); // if this is an array, then iterate over each object

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      obj[i] = multisportify(obj[i]);
    }
  } // recursively upgrade nested objects


  var keys = Object.keys(obj);

  for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
    var key = _keys[_i];

    if (Array.isArray(obj[key])) {
      for (var _i2 in obj[key]) {
        obj[key][_i2] = multisportify(obj[key][_i2]);
      }
    } else if (_typeof(obj[key]) === "object") {
      obj[key] = multisportify(obj[key]);
    }
  }

  return obj;
};

exports.multisportify = multisportify;

var upgradeSoccerAttributes = function upgradeSoccerAttributes(obj) {
  var keys = Object.keys(obj);

  for (var _i3 = 0, _keys2 = keys; _i3 < _keys2.length; _i3++) {
    var key = _keys2[_i3];
    soccerKeyRX.lastIndex = 0;

    if (soccerKeyRX.test(key)) {
      var newKey = key.replace(soccerKeyRX, "");
      obj[newKey] = obj[key];
      delete obj[key];
    }
  }
};